import { tv } from 'tailwind-variants';

interface TopicTextProps {
  description: string;
  title: string;
  className?: string;
  index?: boolean;
}

const topicTextStyle = tv({
  slots: {
    title: ['text-3xl font-extrabold text-gray-900'],
    wrapper: ['flex flex-col text-center md:text-left'],
    description: ['text-gray-800 font-normal'],
  },
  variants: {
    index: {
      true: {
        description: 'text-base',
      },
      false: {
        description: 'text-lg',
      },
    },
  },
});

export function TopicText({ description, title, className, index = false }: TopicTextProps) {
  const { title: titleStyle, wrapper, description: descriptionStyle } = topicTextStyle({ index });

  return (
    <div className={wrapper({ className })}>
      <div>
        <span className={titleStyle()}>{title}</span>
      </div>
      <div>
        <span className={descriptionStyle()}>{description}</span>
      </div>
    </div>
  );
}
